export default "__VITE_ASSET__mEjyf9ym__"